
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/usr/src/nuxtapp/sentry.client.config.js")
            }
          });